export const checkDecimal = value => {
	return Number(value) % 1 === 0
}
